import { type ReportDetail, getReportDetail } from '@/lib/api/reports-client.js';
import { useQuery } from '@tanstack/react-query';

/**
 * Fetches the tenant report detail for a dashboard.
 * Reuses getReportDetail — callers should verify `detail.kind === 'dashboard'`.
 */
export function useDashboardDetail(tenantReportId: string) {
  return useQuery<ReportDetail, Error>({
    queryKey: ['dashboard', tenantReportId],
    queryFn: () => getReportDetail(tenantReportId),
    staleTime: 60_000,
    enabled: tenantReportId.length > 0,
  });
}
